export const formattedMessages = {
  breadcrumb_dashboard: "Dashboard",
  breadcrumb_settings: "Settings",
  breadcrumb_settings_users: "Users",
  breadcrumb_settings_users_list: "Users",
  breadcrumb_settings_users_new: "Create User",
  breadcrumb_settings_users_edit: "Edit User",
  breadcrumb_settings_materials: "Supplies",
  breadcrumb_settings_materials_list: "Supplies",
  breadcrumb_settings_materials_new: "Create Supply",
  breadcrumb_settings_materials_edit: "Edit Supply",
  breadcrumb_settings_services: "Services",
  breadcrumb_settings_services_list: "Services",
  breadcrumb_settings_services_new: "Create Service",
  breadcrumb_settings_services_edit: "Edit Service",
  breadcrumb_settings_services_view: "Service",
  breadcrumb_locations: "Sites",
  breadcrumb_locations_list: "Sites",
  breadcrumb_locations_new: "Create Site",
  breadcrumb_locations_edit: "Edit Site",
  breadcrumb_locations_view: "Site",
  breadcrumb_tickets: "Work Orders",
  breadcrumb_tickets_list: "Work Orders",
  breadcrumb_clients: "Clients",
  breadcrumb_clients_list: "Clients",
  breadcrumb_turbines: "Turbines",
  breadcrumb_turbines_list: "Turbines",
  breadcrumb_tickets_new: "Create Work Order",
  breadcrumb_tickets_edit: "Edit Work Order",
  breadcrumb_clients_new: "Create Client",
  breadcrumb_clients_edit: "Edit Client",
  breadcrumb_clients_view: "Client",
  breadcrumb_turbines_new: "Create Turbine",
  breadcrumb_turbines_edit: "Edit Turbine",
  breadcrumb_turbines_view: "Turbine",
  breadcrumb_tickets_view: "Work Order",
  breadcrumb_notifications: "Notifications",

  menu_header_system_name: "DZ Projects",
  footer_copyright: "© {year} DZ Projects. All rights reserved.",
  menu_header_create: "Create",
  menu_header_current_user: "Current User",
  menu_header_login: "Login",
  menu_header_logout: "Logout",
  menu_side_tickets: "All Work Orders",
  menu_side_create_ticket: "Create Work Order",
  menu_side_clients: "Clients",
  menu_side_create_client: "Create Client",
  menu_side_turbines: "Turbines",
  menu_side_create_turbines: "Create Turbine",
  menu_side_locations: "All Sites",
  menu_side_create_location: "Create Site",

  nav_group_work_orders: "Work Orders",
  nav_work_orders_all: "All Work Orders",
  nav_work_orders_new: "New",
  nav_work_orders_in_progress: "In Progress",
  nav_work_orders_standby: "Standby",
  nav_work_orders_in_review: "In Review",
  nav_work_orders_done: "Done",
  nav_group_clients: "Clients",
  nav_group_turbines: "Turbines",
  nav_group_locations: "Sites",
  nav_group_settings: "Settings",
  menu_side_users: "Users",
  menu_side_create_user: "Create User",
  menu_side_materials: "Supplies",
  menu_side_create_material: "Create Supply",
  menu_side_services: "Services",
  nav_dashboard: "Dashboard",
  nav_notifications: "Notifications",

  wo_notifications_title: "Notifications",
  wo_notifications_subtitle: `
  {no, plural,
    one {{no, number} unread notification}
    other {{no, number} unread notifications}
  }
  `,
  wo_notifications_search_placeholder: "Search work order, technician",
  wo_notifications_type_filter_placeholder: "Notification type",
  wo_notifications_unread_only: "Unread only",
  wo_notifications_open_button: "Open",
  wo_notifications_mark_read_button: "Mark as read",

  dashboard_title: "Overview",
  dashboard_refresh: "Refresh",
  dashboard_kpi_new: "New",
  dashboard_kpi_in_progress: "In Progress",
  dashboard_kpi_done: "Completed",
  dashboard_kpi_overdue: "Overdue",
  dashboard_kpi_due_soon: "Due This Week",
  dashboard_fleet_clients: "Clients",
  dashboard_fleet_turbines: "Turbines",
  dashboard_fleet_technicians: "Technicians",
  dashboard_section_services: "By Service Type",
  dashboard_section_priority: "By Priority",
  dashboard_section_fleet: "Fleet",
  dashboard_section_recent: "Recent Work Orders",
  dashboard_no_data: "No data yet",

  table_header_name: "All Work Orders",
  table_header_number_of_items: `
    {no, plural,
      one {{no, number} work order}
      other {{no, number} work orders}
    }
  `,
  table_header_search_placeholder: "Name, description, site",
  table_column_name: "Name",
  table_column_ticket_number: "#",
  table_column_client_case_nr: "Client Case Number",
  table_column_description: "Description",
  table_column_location: "Site",
  table_column_service: "Service",
  table_column_turbine: "Turbine",
  table_column_client: "Client",
  table_column_created_at: "Created At",
  table_column_status: "Status",
  table_column_report: "Report",
  table_column_priority: "Priority",
  table_column_start: "Start Date",
  table_column_deadline: "Due Date",
  table_column_last_updated: "Last Updated",
  table_column_assignee: "Assignee",
  table_column_created_by: "Created By",
  table_column_actions: "Actions",

  client_table_header_search_placeholder: "Name, Code",
  client_table_header_name: "Clients",
  client_table_header_number_of_items: `
  {no, plural,
    one {{no, number} client}
    other {{no, number} clients}
  }
  `,
  client_table_column_name: "Name",
  client_table_column_tax: "Code",
  client_table_column_address: "Address",
  client_table_column_contact_name: "Contact",
  client_table_column_contact_email: "Email",
  client_table_column_contact_phone: "Phone Number",
  client_table_column_last_updated: "Updated At",
  client_table_column_created_by: "Created",
  client_delete_confirmation: "Delete this client?",
  client_create_button: "New Client",

  client_create_title: "New Client",
  client_create_subtitle: "Fill in the details to create a client",
  client_edit_title: "Edit Client",
  client_section_details: "Client Details",
  client_section_contact: "Contact Information",

  client_legal_name: "Name",
  client_tax_id: "Code",
  client_billing_address: "Address",
  client_contact_name: "Contact",
  client_contact_email: "Email",
  client_contact_phone: "Phone Number",

  turbine_table_header_name: "Turbines",
  turbine_table_header_number_of_items: `
  {no, plural,
    one {{no, number} turbine}
    other {{no, number} turbines}
  }
  `,
  turbine_table_header_search_placeholder: "Serial number, park number, client, site",
  turbine_table_column_client: "Client",
  turbine_table_column_serial_number: "Serial Number",
  turbine_table_column_park_number: "Park Number",
  turbine_table_column_latitude: "Latitude",
  turbine_table_column_longitude: "Longitude",
  turbine_table_column_location: "Site",
  turbine_table_column_created_at: "Created At",
  turbine_table_column_updated_at: "Updated At",
  turbine_delete_confirmation: "Delete this turbine?",
  turbine_create_button: "New Turbine",

  turbine_create_title: "New Turbine",
  turbine_create_subtitle: "Fill in the details to create a turbine",
  turbine_edit_title: "Edit Turbine",
  turbine_section_details: "Turbine Details",
  turbine_section_assignment: "Assignment",
  turbine_map: "Map",

  turbine_serial_number: "Serial Number",
  turbine_park_number: "Park Number",
  turbine_latitude: "Latitude",
  turbine_longitude: "Longitude",
  turbine_location: "Site",
  turbine_service_lift: "Service Lift",
  turbine_fall_protection_system: "Fall Protection System",
  turbine_components: "Components",

  turbine_filter_label_client: "Client",

  location_table_header_name: "Sites",
  location_table_header_number_of_items: `
  {no, plural,
    one {{no, number} location}
    other {{no, number} locations}
  }
  `,
  location_table_header_search_placeholder: "Name, Country",
  location_table_column_name: "Name",
  location_table_column_country: "Country",
  location_table_column_description: "Description",
  location_delete_confirmation: "Delete this site?",
  location_create_button: "New Site",

  location_name: "Name",
  location_description: "Description",
  location_country: "Country",
  location_create_title: "New Site",
  location_create_subtitle: "Fill in the details to create a site",
  location_edit_title: "Edit Site",
  location_section_details: "Site Details",

  validation_message_location_name: "Please provide a name",
  validation_message_location_description: "Please provide a description",
  validation_message_location_country: "Please provide a country",

  notification_location_create_success: "Site created",
  notification_location_update_success: "Site updated",
  notification_location_delete_success: "Site deleted",

  component_table_column_type: "Type",
  component_table_column_manufacturer: "Manufacturer",
  component_table_column_model: "Model",
  component_table_column_serial_number: "Serial No.",
  component_table_column_set_number: "SET No.",
  component_table_column_created_at: "Created At",
  component_table_column_updated_at: "Updated At",
  component_type_BLADE: "Blade",
  component_type_NACELLE: "Nacelle",
  component_type_HUB: "Hub",
  component_type_TOWER: "Tower",

  filter_header_name: "Filter",
  filter_header_clear_button: "Clear",
  filter_header_filter_button: "Filter",
  filter_label_status: "Status",
  filter_label_assignee: "Assignee",
  filter_label_service: "Service",
  filter_label_created_by: "Created By",
  filter_label_turbine: "Turbine",
  filter_label_client: "Client",

  login_header: "Welcome back",
  login_subheader: "Sign in to your account to continue",
  login_field_username: "Username",
  login_field_password: "Password",
  login_field_remember: "Remember me",
  login_button_submit: "Submit",
  login_field_totp: "2FA Code",
  login_field_totp_placeholder: "6-digit code",
  login_input_username_missing: "Please input your username!",
  login_input_password_missing: "Please input your password!",
  login_step2_header: "Two-factor authentication",
  login_step2_subheader: "Enter the 6-digit code from your authenticator app",
  login_field_totp_missing: "Please enter the 6-digit code",
  login_back: "Back",
  login_button_verify: "Verify",
  login_error_invalid_credentials: "Invalid username or password",
  login_error_invalid_totp: "Invalid code, please try again",
  login_error_session_expired: "Session expired, please start again",
  login_error_network: "Network error, please try again",
  login_email_code_hint: "Enter the 6-digit code we sent to your email",
  login_email_code_resend_hint: "Didn't get it? Go back and sign in again to resend.",
  login_error_invalid_email_code:
    "Invalid or expired code. Check your email or go back to sign in again.",

  set_password_header: "Set your password",
  set_password_subheader: "Choose a password to sign in with",
  set_password_field_password: "New Password",
  set_password_field_confirm: "Confirm Password",
  set_password_input_password_missing: "Please enter a password.",
  set_password_input_confirm_missing: "Please confirm your password.",
  set_password_error_mismatch: "Passwords do not match.",
  set_password_button_submit: "Set Password",
  set_password_invalid_link:
    "This link is invalid or has expired. Please contact your administrator or request a new one.",
  set_password_invalid_link_title: "Invalid Link",
  set_password_error_generic: "Failed to set password. Please try again.",

  forgot_password_link: "Forgot password?",
  forgot_password_header: "Reset your password",
  forgot_password_subheader:
    "Enter your email and we'll send you a link to reset your password.",
  forgot_password_field_email: "Email",
  forgot_password_input_email_missing: "Please enter your email.",
  forgot_password_input_email_invalid: "Please enter a valid email address.",
  forgot_password_button_submit: "Send reset link",
  forgot_password_success_title: "Check your email",
  forgot_password_success_message:
    "If an account exists for that email, we've sent a password reset link. Please check your inbox.",
  forgot_password_error_network: "Network error, please try again.",
  forgot_password_back_to_login: "Back to login",

  ticket_name: "Ticket Name",
  ticket_description: "Description",
  ticket_service: "Service",
  ticket_location: "Site",
  ticket_location_placeholder: "Select a turbine first",
  ticket_client_case_number: "Case Number",
  ticket_start: "Start Date",
  ticket_deadline: "Due Date",
  ticket_actual_start: "Actual Start",
  ticket_actual_end: "Actual End",
  ticket_resolution: "Resolution",
  ticket_delay_reason: "Standby Reason",
  ticket_summary: "Summary",
  ticket_summary_callout_title: "Technician's Summary",
  ticket_assignee: "Assignee",
  ticket_coordinator: "Project Coordinator",
  ticket_manager: "Project Manager",
  ticket_priority: "Priority",
  ticket_component_select_placeholder: "Select component",
  ticket_service_select_placeholder: "Select Service",
  ticket_button_start: "Start",
  ticket_status_done_modal_title: "Complete Work Order",
  ticket_status_done_modal_label: "Summary",
  ticket_status_done_modal_placeholder: "Describe what was done...",
  ticket_status_delay_modal_title: "Report Standby",
  ticket_status_delay_modal_label: "Message (optional)",
  ticket_status_delay_modal_placeholder: "Describe the reason for the delay...",
  ticket_status_delay_modal_standby_from_label: "Standby start",
  ticket_status_delay_modal_standby_from_hint:
    "Defaults to now. Set a past time to backdate a standby that already began, or a future time to schedule one — the work order stays active until then.",
  ticket_status_delay_modal_standby_from_placeholder: "Select start date and time",
  ticket_status_delay_modal_standby_from_invalid:
    "Start time must be before the standby-until time.",
  ticket_status_delay_modal_standby_until_label: "Standby until (optional)",
  ticket_status_delay_modal_standby_until_hint:
    "Leave empty for indefinite standby — resume manually.",
  ticket_status_delay_modal_standby_until_placeholder: "Select date and time",
  ticket_status_reject_modal_title: "Reject Work Order",
  ticket_status_reject_modal_label: "Reason (optional)",
  ticket_status_reject_modal_placeholder: "Describe what needs to be corrected...",
  ticket_button_title_cancel: "Cancel",
  ticket_button_title_create: "Confirm",
  ticket_delete_confirmation: "Delete this ticket?",
  ticket_create_title: "New Work Order",
  ticket_create_subtitle: "Fill in the details to create a work order",
  ticket_edit_title: "Edit Work Order",
  ticket_rating_label: "Rating",
  ticket_rating_comment_label: "Rating Comment",
  ticket_rating_comment_placeholder: "Add a comment about the work (optional)",
  ticket_rating_comment_requires_rating: "Rate the work to add a comment",
  ticket_rating_comment_save: "Save Comment",
  ticket_section_general: "General",
  ticket_section_details: "Work Order Details",
  ticket_section_assignment: "Assignment",
  ticket_section_files: "Files",
  ticket_files_empty: "No files attached",
  ticket_file_preview: "Preview",
  ticket_file_download: "Download",
  ticket_file_name: "File",
  ticket_file_description: "Description",
  ticket_file_size: "Size",
  ticket_file_delete: "Delete",
  ticket_file_delete_confirm_title: "Delete this file?",
  ticket_file_delete_confirm_content:
    "This file will be permanently removed from the ticket.",
  file_delete_not_owner: "You can only delete files you uploaded.",
  ticket_file_preview_unavailable:
    "Preview not available for this file type. Download it to view.",
  ticket_files_download_all: "Download all files",
  ticket_files_export_running: "A file export is already in progress",
  ticket_files_export_no_space:
    "Not enough browser storage available to prepare the download",
  ticket_files_export_downloading: "Downloading files…",
  ticket_files_export_zipping: "Compressing files…",
  ticket_files_export_ready_title: "Files are ready for download",
  ticket_files_export_ready_content: "The archive has been prepared. Download it now?",
  ticket_files_export_download: "Download",
  ticket_files_export_failed: "File export failed",
  ticket_tab_files: "Files",
  ticket_tab_check_in_out_log: "Check In/Out Log",
  ticket_tab_check_in_out_log_short: "Check In/Out",
  ticket_tab_task_log: "Task Log",
  ticket_tab_wo_history: "WO History",
  ticket_tab_wo_history_short: "History",
  ticket_tab_supplies: "Supplies",
  ticket_section_supplies: "Supplies",
  ticket_supplies_select_placeholder: "Select supplies",
  work_log_empty: "No work log entries",
  work_log_column_date: "Date",
  work_log_column_changes: "Changes",
  work_log_added: "Added",
  work_log_removed: "Removed",
  work_log_changed_by: "by {actor}",
  work_log_unknown_date: "Unknown date",
  work_log_rejection_entry_label: "Work Order Rejected",
  work_log_standby_entry_label: "Standby Reported",
  work_log_standby_duration_label: "Standby Time",
  ticket_supplies_empty: "No supplies attached",
  ticket_supplies_column_material: "Material",
  ticket_supplies_column_added: "Added",
  ticket_supplies_amount_label: "Amount Used",
  ticket_supplies_amount_placeholder: "Enter amount",
  ticket_supplies_unit_placeholder: "Unit",
  ticket_supplies_unit_required: "Select a unit for the amount",
  ticket_supplies_batch_label: "Batch No",
  ticket_supplies_batch_placeholder: "Enter batch number",
  ticket_supplies_save: "Save",
  ticket_supplies_saved: "Saved",
  ticket_supplies_not_used: "Not used",
  ticket_supplies_progress: "{saved} / {total} recorded",
  ticket_supplies_save_error: "Failed to save — check connection",
  ticket_supplies_column_sap_code: "SAP Code",
  ticket_supplies_column_amount: "Amount Used",
  ticket_supplies_column_batch: "Batch No",
  ticket_supplies_column_status: "Status",
  ticket_supplies_status_used: "Used",
  ticket_supplies_status_not_recorded: "Not recorded",
  ticket_supplies_usage_summary: "{used} of {total} materials recorded",
  ticket_supply_expiration_date: "Expiration Date",
  ticket_supply_expiration_placeholder: "Select date",

  validation_message_max_length: "Maximum {max} characters",
  validation_message_ticket_name: "Please provide a ticket name",
  validation_message_ticket_description: "Please provide a description",
  validation_message_ticket_location: "Please provide a site",
  validation_message_ticket_service: "Please select a service",
  validation_message_ticket_assignee: "Please select an assignee",
  validation_message_ticket_status: "Please select status",
  validation_message_ticket_turbine: "Please select a turbine",
  validation_message_ticket_client: "Please select a client",
  validation_message_ticket_client_case_number: "Please provide a case number",
  validation_message_ticket_priority: "Please select priority",

  validation_message_client_legal_name: "Please provide a company name",
  validation_message_client_tax_id: "Please provide a description",
  validation_message_client_billing_address: "Please provide an address",
  validation_message_client_contact_name: "Please provide a contact name",
  validation_message_client_contact_email: "Please provide a valid email",
  validation_message_client_contact_phone: "Please provide a phone number",

  validation_message_turbine_serial_number:
    "Please provide a 5 digit turbine serial number",
  validation_message_turbine_latitude: "Please provide latitude coordinates",
  validation_message_turbine_longitude: "Please provide longitude coordinates",
  validation_message_turbine_location: "Please select a site",
  validation_message_turbine_client: "Please select a client",

  notification_error_network_generic:
    "Connection lost. Please check your internet connection and try again.",
  notification_error_server_generic:
    "We're having trouble loading this right now. Please try again in a few moments",
  notification_error_authorization_denied:
    "Not authorized to access the requested resource",
  page_error_not_found_title: "Page not found",
  page_error_not_found_subtitle:
    "The item you're looking for doesn't exist or has been removed.",
  page_error_forbidden_title: "Access denied",
  page_error_forbidden_subtitle:
    "You don't have permission to view this item.",
  page_error_generic_title: "Something went wrong",
  page_error_generic_subtitle: "The page could not be loaded.",
  page_error_go_to_dashboard: "Go to Dashboard",
  page_error_go_back: "Go back",
  notification_ticket_start_success: "Work order started",
  notification_ticket_end_success: "Work order completed",
  notification_ticket_delay_success: "Standby reported",
  notification_ticket_review_success: "Work order set to In Review",
  notification_ticket_confirm_success: "Work order confirmed as done",
  notification_ticket_reject_success: "Work order returned to In Progress",
  notification_ticket_create_success: "Ticket created",
  notification_ticket_update_success: "Ticket updated",
  notification_ticket_delete_success: "Ticket deleted",
  notification_client_create_success: "Client created",
  notification_client_update_success: "Client updated",
  notification_client_delete_success: "Client deleted",
  notification_turbine_create_success: "Turbine created",
  notification_turbine_delete_success: "Turbine deleted",
  notification_turbine_update_success: "Turbine updated",
  notification_component_update_success: "Component updated",
  notification_user_create_success: "User created",
  notification_user_update_success: "User updated",
  notification_user_delete_success: "User deleted",
  notification_user_deactivate_success: "User deactivated",
  notification_user_reactivate_success: "User reactivated",

  validation_error: "bad request syntax or unsupported method",
  authentication_error: "no permission -- see authorization schemes",
  permission_error: "not authorized to access the requested resource",
  query_error: "nothing matches the given query",

  confirm: "Confirm",
  cancel: "Cancel",
  detailed_information: "Detailed Information",
  work_orders: "Work Orders",
  turbines: "Turbines",
  projects: "Projects",

  common_no_data: "No Data",

  upload_choose_files: "Click or drag files to this area to upload",
  upload_hint: "Support for single or bulk upload",
  upload_uploading: "Uploading file...",
  upload_success: "File uploaded",
  upload_failed: "Failed to upload file",
  failed_to_upload: "Failed to upload file",
  failed_to_upload_retry: "Upload failed. Remove and try again.",
  comment_attach_files: "Attach files",
  comment_react: "React",
  comment_reaction_you: "You",
  comment_reaction_chip_label: "{reaction}, {count}: {names}",
  comment_reaction_thumbs_up: "Thumbs up",
  comment_reaction_check: "Check mark",
  comment_reaction_eyes: "Eyes",
  comment_reaction_heart: "Heart",

  // user management
  user_table_header_name: "Users",
  user_table_header_number_of_items: `
    {no, plural,
      one {{no, number} user}
      other {{no, number} users}
    }
  `,
  user_table_header_search_placeholder: "Username, email",
  table_column_username: "Username",
  table_column_full_name: "Full Name",
  table_column_email: "Email",
  table_column_first_name: "First Name",
  table_column_last_name: "Last Name",
  table_column_is_active: "Active",
  table_column_is_staff: "Staff",
  table_column_last_login: "Last Login",
  user_delete_confirmation: "Delete this user?",
  user_create_button: "New User",
  user_create_title: "New User",
  user_create_subtitle: "Fill in the details to create a user",
  user_edit_title: "Edit User",
  user_section_details: "User Details",
  user_username: "Username",
  user_email: "Email",
  user_first_name: "First Name",
  user_last_name: "Last Name",
  user_password: "Password",
  user_is_staff: "Staff",
  user_is_superuser: "Superuser",
  user_active: "Active",
  user_inactive: "Inactive",
  user_staff_yes: "Staff",
  user_staff_no: "Not Staff",
  user_is_active_filter: "Active",
  user_is_staff_filter: "Staff",
  user_action_deactivate: "Deactivate",
  user_action_reactivate: "Reactivate",
  validation_message_user_username: "Username is required",
  validation_message_user_email: "A valid email is required",
  validation_message_user_password: "Password is required",
  table_column_phone_number: "Phone",
  table_column_technician_level: "Level",
  table_column_groups: "Role",
  user_phone_number: "Phone Number",
  user_group: "Role",
  user_technician_level: "Technician Level",
  user_technician_level_l1: "Level 1",
  user_technician_level_l2: "Level 2",
  user_technician_level_l3: "Level 3",
  validation_message_user_phone_number: "Phone number is required",

  // projects
  breadcrumb_projects: "Projects",
  breadcrumb_projects_list: "Projects",
  breadcrumb_projects_new: "Create Project",
  breadcrumb_projects_edit: "Edit Project",
  breadcrumb_projects_view: "Project",

  nav_group_projects: "Projects",
  nav_projects_all: "All Projects",
  nav_projects_active: "Active",
  nav_projects_completed: "Completed",
  nav_projects_delayed: "Delayed",
  menu_side_projects: "All Projects",
  menu_side_create_project: "Create Project",

  project_table_header_name: "Projects",
  project_table_header_number_of_items: `
    {no, plural,
      one {{no, number} project}
      other {{no, number} projects}
    }
  `,
  project_table_header_search_placeholder: "Search projects",
  project_table_column_name: "Name",
  project_table_column_status: "Status",
  project_table_column_start: "Start Date",
  project_table_column_end: "End Date",
  project_table_column_client: "Client",
  project_table_column_created_at: "Created",
  project_delete_confirmation: "Are you sure you want to delete this project?",
  project_delete_button: "Delete",
  project_create_button: "New Project",

  project_create_title: "New Project",
  project_create_subtitle: "Fill in the details to create a project",
  project_edit_title: "Edit Project",
  project_section_details: "Project Details",

  project_name: "Name",
  project_status: "Status",
  project_start_date: "Start Date",
  project_end_date: "End Date",
  project_label: "Project",
  project_client: "Client",
  project_field_name_placeholder: "Project name",
  project_field_status_placeholder: "Select status (optional)",
  project_field_client_placeholder: "Select client (optional)",
  project_field_project_placeholder: "Select project (optional)",

  validation_message_project_name: "Please provide a project name",
  validation_message_end_after_start: "End date must be after start date",

  notification_project_create_success: "Project created",
  notification_project_update_success: "Project updated",
  notification_project_delete_success: "Project deleted",
  notification_project_marked_delayed:
    "Project marked as Delayed. Work orders moved to Standby.",
  notification_project_resumed: "Project resumed. Work orders moved to New.",

  // services
  service_table_header_name: "Services",
  service_table_header_number_of_items: `
    {no, plural,
      one {{no, number} service}
      other {{no, number} services}
    }
  `,
  service_table_header_search_placeholder: "Name",
  service_create_button: "New Service",
  service_create_title: "New Service",
  service_create_subtitle: "Fill in the details to create a service",
  service_edit_title: "Edit Service",
  service_section_details: "Service Details",
  service_name: "Name",
  service_description: "Description",
  service_delete_confirmation: "Delete this service?",
  validation_message_service_name: "Name is required",
  validation_message_service_description: "Description is required",
  notification_service_create_success: "Service created",
  notification_service_update_success: "Service updated",
  notification_service_delete_success: "Service deleted",
  service_section_supplies: "Supplies",
  service_supplies_empty: "No supplies assigned to this service",
  service_change_confirm_title: "Replace supplies?",
  service_change_confirm_content:
    "Changing service will replace current supplies with service defaults. Continue?",

  // supplies (materials)
  material_table_header_name: "Supplies",
  material_table_header_number_of_items: `
    {no, plural,
      one {{no, number} supply}
      other {{no, number} supplies}
    }
  `,
  material_table_header_search_placeholder: "Name",
  material_create_button: "New Supply",
  material_create_title: "New Supply",
  material_create_subtitle: "Fill in the details to create a supply",
  material_edit_title: "Edit Supply",
  material_section_details: "Supply Details",
  material_name: "Name",
  material_category: "Category",
  material_category_chemicals: "Chemicals",
  material_category_fabric: "Fabric",
  material_batch: "SAP Code",
  material_delete_confirmation: "Delete this supply?",
  validation_message_material_name: "Name is required",
  validation_message_material_category: "Category is required",
  notification_material_create_success: "Supply created",
  notification_material_update_success: "Supply updated",
  notification_material_delete_success: "Supply deleted",

  // user profile
  breadcrumb_me: "My Profile",
  breadcrumb_users: "Profiles",
  breadcrumb_users_view: "User Profile",
  breadcrumb_users_edit: "Edit Profile",
  profile_edit_button: "Edit Profile",
  profile_change_password: "Change Password",
  profile_section_info: "Profile Information",
  profile_first_name: "First Name",
  profile_last_name: "Last Name",
  profile_username: "Username",
  profile_username_readonly_hint: "Cannot be changed",
  profile_phone: "Phone Number",
  profile_email: "Email",
  profile_email_readonly_hint: "Cannot be changed",
  profile_role: "Role",
  profile_technician_level: "Technician Level",
  profile_member_since: "Member Since",
  profile_staff_badge: "Staff",
  profile_no_name: "—",
  profile_edit_title: "Edit Profile",
  profile_edit_save: "Save Changes",
  profile_change_password_title: "Change Password",
  profile_change_password_old: "Current Password",
  profile_change_password_new: "New Password",
  profile_change_password_confirm: "Confirm New Password",
  profile_change_password_mismatch: "New passwords do not match",
  profile_change_password_old_required: "Current password is required",
  profile_change_password_new_required: "New password is required",
  profile_change_password_confirm_required: "Please confirm your new password",
  notification_profile_update_success: "Profile updated",
  notification_password_change_success: "Password changed successfully",

  ticket_tasks: "Tasks",
  ticket_task_component: "Component",
  ticket_task_service: "Service",
  ticket_task_estimated_time: "Estimate",
  ticket_task_actual_time: "Spent Time",
  ticket_task_log_time: "Log Time",
  ticket_task_completed: "Completed",
  ticket_button_add_task: "Add Task",
  ticket_task_upload_file: "Upload File",
  ticket_task_files_download_all: "Download All Files",
  ticket_task_files_button: "Files",
  ticket_task_file_drawer_title: "Files — Task #{taskNumber}",
  ticket_task_files_empty: "No files uploaded yet",
  ticket_task_comment: "Comment",
  ticket_task_comment_drawer_title: "Comments — Task #{taskNumber}",
  ticket_task_file_column: "Task",
  ticket_task_mark_done: "Mark Done",
  ticket_task_mark_done_requires_time: "Log time before marking as done",
  ticket_task_total_time_label: "Logged",
  ticket_task_log_more: "Log More",
  ticket_task_time_spent_label: "Hours Spent",
  ticket_task_time_spent_required: "Please enter hours spent",
  ticket_task_log_time_error: "Failed to log time. Please try again.",
  ticket_task_log_time_success: "Time logged successfully",
  ticket_task_add_title: "Add Task",
  ticket_task_edit_title: "Edit Task",
  ticket_task_delete_title: "Delete Task",
  ticket_task_delete_confirm: "Are you sure you want to delete this task?",
  ticket_task_estimated_time_placeholder: "e.g. 2.5",
  ticket_task_actual_time_placeholder: "e.g. 4h 30min",
  ticket_task_detail_section: "Task Detail",
  ticket_task_time_section: "Time",
  ticket_task_column: "Task",
  ticket_task_time_column: "Time",
  ticket_task_no_time_logged: "No time logged",
  ticket_task_filter_all: "All",
  ticket_task_filter_todo: "To Do",
  ticket_task_filter_completed: "Completed",
  validation_message_ticket_tasks: "Please add at least 1 task",
  validation_message_ticket_task_component: "Please select the component",

  ticket_tab_work_history: "Work History",
  ticket_time_sessions_section: "Time Sessions",
  ticket_changelog_section: "Change Log",
  ticket_check_in: "Check In",
  ticket_check_out: "Check Out",
  ticket_check_in_modal_title: "Check In",
  ticket_check_out_modal_title: "Check Out",
  ticket_check_in_time_label: "Check-in time",
  ticket_check_out_time_label: "Check-out time",
  ticket_elapsed_label: "Elapsed",
  ticket_adjust_time: "Adjust",
  ticket_check_in_success: "Checked in successfully",
  ticket_check_out_success: "Checked out successfully",
  ticket_checked_in_heading: "Checked in",
  ticket_checked_out_heading: "Checked out",
  ticket_copy_report_hint: "Copy this session's report to paste into a message.",
  ticket_copy_report: "Copy report",
  ticket_report_copied: "Copied",
  ticket_done: "Done",
  ticket_check_in_blocked_title: "Already Checked In",
  ticket_check_in_blocked_message:
    "You are already checked in to Work Order #{number}. Check out there before checking in here.",
  ticket_check_in_blocked_message_generic:
    "You are already checked in to another Work Order. Check out there before checking in here.",
  ticket_check_in_blocked_go_to_wo: "Go to Work Order",
  ticket_check_in_blocked_message_ticketless:
    "You have an open check-in. Check out before starting a new one.",
  ticket_check_in_blocked_dismiss: "OK",
  checkin_active_blocks_complete: "Check out before completing this Work Order",
  checkin_active_blocks_approve:
    "A technician is still checked in — they must check out before this can be approved",
  ticket_time_sessions_empty: "No time sessions recorded",
  ticket_time_session_active: "Active",
  ticket_total_time_label: "Check-In/Out Time",
  ticket_total_standby_time_label: "Total Standby Time",
  ticket_estimated_task_time_label: "Estimated Task Time",
  ticket_logged_task_time_label: "Logged Task Time",
  table_column_total_time: "Time Spent",
  table_column_active_checkin: "Check-In",
  ticket_session_col_technicians: "Technicians",
  ticket_session_col_check_in: "Check In",
  ticket_session_col_check_out: "Check Out",
  ticket_session_col_duration: "Duration",
  ticket_session_col_turbine_stopped: "Turbine Stopped",
  ticket_session_checkin_details: "Check In Details",
  ticket_session_checkout_details: "Check Out Details",
  ticket_session_field_task: "Task",
  ticket_session_field_component: "Components",
  ticket_session_field_progress: "Plan For Today",
  ticket_session_field_progress_checkout: "Work Done Today",
  ticket_session_field_weather: "Weather",
  ticket_session_field_dam: "DAM",
  ticket_session_field_df: "DF",
  ticket_session_field_car: "Vehicle",
  ticket_session_field_turbine_stopped: "Turbine Stopped",
  ticket_session_no_checkout_yet: "Not yet checked out",
  ticket_session_copy_full_label: "Full",
  ticket_session_copy_checkin_label: "In",
  ticket_session_copy_checkout_label: "Out",
  ticket_session_copy_full_tooltip: "Copy full session report (check-in + check-out)",
  ticket_session_copy_checkin_tooltip: "Copy check-in details only",
  ticket_session_copy_checkout_tooltip: "Copy check-out details only",
  ticket_session_copy_checkout_disabled_tooltip:
    "No check-out yet — session still active",

  ticket_task_log_empty: "No time logged against tasks",
  ticket_task_log_col_task: "Task",
  ticket_task_log_col_date: "Date",
  ticket_task_log_col_hours: "Logged",

  ticket_time_edit_action: "Edit",
  ticket_time_edit_tooltip: "Edit the recorded times",
  ticket_time_edit_title_session: "Edit Session Times",
  ticket_time_edit_title_task: "Edit Logged Time",
  ticket_time_edit_start_date: "Check-in Date",
  ticket_time_edit_start_time: "Check-in Time",
  ticket_time_edit_end_date: "Check-out Date",
  ticket_time_edit_end_time: "Check-out Time",
  ticket_time_edit_date: "Date",
  ticket_time_edit_hours: "Hours Spent",
  ticket_time_edit_required: "This field is required",
  ticket_time_edit_cohort_notice:
    "This change applies to every technician on this session: {technicians}.",
  ticket_time_edit_active_note:
    "This session is still active — only the check-in time can be changed.",
  ticket_time_edit_end_before_start: "Check-out must be after check-in.",

  checkin_section_work_details: "Work Details",
  checkin_section_site_conditions: "Site Conditions",
  checkin_section_logistics: "Logistics",
  checkin_field_task: "Task Description",
  checkin_field_task_placeholder: "Describe the task to be performed",
  checkin_field_task_required: "Task description is required",
  checkin_field_progress: "Plan For Today",
  checkin_field_progress_placeholder: "Describe what you plan to do today",
  checkin_field_progress_required: "Plan For Today is required",
  checkin_field_weather: "Weather Conditions",
  checkin_field_weather_placeholder: "e.g. Clear, Windy, Rainy",
  checkin_field_weather_required: "Weather conditions are required",
  checkin_field_component: "Components",
  checkin_field_component_placeholder: "Select the components you are working on",
  checkin_field_component_required: "Please select at least one component",
  checkin_field_dam: "DAM",
  checkin_field_dam_placeholder: "Describe any damage or anomalies observed",
  checkin_field_dam_required: "Damage assessment is required",
  checkin_field_df: "DF",
  checkin_field_df_placeholder: "Describe any defects or findings observed",
  checkin_field_df_required: "DF is required",
  checkin_field_turbine_stopped: "Turbine Stopped",
  checkin_field_turbine_stopped_required:
    "Please indicate whether the turbine is stopped",
  checkin_turbine_stopped_yes: "Yes",
  checkin_turbine_stopped_no: "No",
  checkin_field_car: "Vehicle",
  checkin_field_car_placeholder: "Vehicle registration or description",
  checkin_field_car_required: "Vehicle is required",
  checkin_section_checkin_time: "Check In Time",
  checkin_field_date: "Check-in Date",
  checkin_field_time: "Check-in Time",
  // Raised by both check-in and the time entry edit, and the error interceptor cannot
  // tell which, so the wording has to cover every case that produces it.
  checkin_error_incorrect_date:
    "Selected time isn't valid — it can't be in the future, can't end before it starts, and can't precede your last check-out.",
  validation_check_out_required:
    "You're still checked in to another Work Order. Check out there before checking in here.",
  validation_standby_to_must_be_future: "The standby date must be in the future.",
  validation_standby_from_must_precede_standby_to:
    "The standby start must be earlier than the standby end.",
  validation_ticket_must_be_in_review:
    "This Work Order must be in review before it can be approved or rejected.",
  validation_ticket_approved:
    "This Work Order is approved — its recorded times can no longer be changed.",
  validation_overlapping_session:
    "That time overlaps another check-in session for one of these technicians.",
  validation_incorrect_format: "That change couldn't be applied. Please try again.",
  validation_overlapping_standby_period:
    "That time overlaps another standby period on this Work Order.",
  validation_cannot_reopen_standby_period:
    "A standby period that has already ended can't be reopened.",
  standby_period_edit_title: "Edit Standby Period",
  standby_period_edit_start_date: "Standby Start Date",
  standby_period_edit_start_time: "Standby Start Time",
  standby_period_edit_end_date: "Standby End Date",
  standby_period_edit_end_time: "Standby End Time",
  standby_period_edit_reason: "Standby Reason",
  standby_period_edit_in_future: "Standby times can't be in the future.",
  standby_period_edit_end_before_start: "Standby end must be after standby start.",
  standby_period_edit_action: "Edit standby period",
  ticket_tab_standby: "Standby",
  standby_tab_column_start: "Start",
  standby_tab_column_end: "End",
  standby_tab_column_duration: "Duration",
  standby_tab_column_reason: "Reason",
  standby_tab_column_started_by: "Started by",
  standby_tab_column_ended_by: "Ended by",
  standby_tab_ongoing: "Ongoing",
  standby_tab_empty: "No standby periods on this Work Order",
  standby_tab_total_completed: "Total standby (completed periods): {total}",
  notification_standby_period_edit_success: "Standby period updated",
  time_entry_edit_not_owner: "You can only edit time entries recorded for you.",
  notification_time_entry_edit_success: "Time updated",
  checkout_section_checkout_time: "Check Out Time",
  checkout_field_date: "Checkout Date",
  checkout_field_time: "Checkout Time",
  // The progress field is forward-looking at check-in and retrospective at
  // check-out, so each phase has its own wording for the same stored field.
  checkout_field_progress: "Work Done Today",
  checkout_field_progress_placeholder: "Describe what you did today",
  checkout_field_progress_required: "Work done today is required",

  // field app dashboard
  field_dashboard_title: "Dashboard",
  field_dashboard_loading: "Loading dashboard…",
  field_dashboard_error: "Failed to load dashboard data. Please try again.",
  field_dashboard_active_checkin_title: "Active Check-In",
  field_dashboard_checkin_elapsed: "Checked in for {hours}",
  field_dashboard_forgotten_checkin_title: "Forgotten Check-In",
  field_dashboard_forgotten_checkin_desc: "You have been checked in for over 8 hours.",
  field_dashboard_quick_checkout: "Quick Check Out",
  field_dashboard_my_work_orders: "My Work Orders",
  field_dashboard_active_queue: "Active Queue",
  field_dashboard_approaching_deadline: "Approaching Deadline",
  field_dashboard_overdue: "Overdue",
  field_dashboard_no_active_wos: "No active work orders.",
  field_dashboard_pending_tasks: "Tasks Pending Completion",
  field_dashboard_no_pending_tasks: "No pending tasks.",
  field_dashboard_delayed_projects: "Project Delays Affecting Me",
  field_dashboard_wo_ref: "WO #{number}",

  // time and date
  short_date: "{value, date, ::yyyyMMdd}",
  full_date: "{value, date, ::yyyyMMdd} {value, date, ::HHmm}",
  time: "{value, date, ::HHmm}",
  verbose_short_date: "{value, date, ::yyyyLLLLd}",
  verbose_date: "{value, date, ::LLLLdeeeee}",
  date_format: "yyyy-MM-dd",
};
